import { Layers } from "lucide-react";
import { useTranslation } from "react-i18next";

export function DimensionsListTitle() {
  const { t } = useTranslation("projects");
  return (
    <div className="flex items-center gap-2.5">
      <Layers className="h-5 w-5 shrink-0 text-zinc-700" />
      <span className="text-lg font-medium tracking-tight text-zinc-900">{t("dimensions.heading")}</span>
    </div>
  );
}
